"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PasswordValidator = void 0;
var PasswordValidator;
(function (PasswordValidator) {
    PasswordValidator.PASSWORD_REQUIREMENTS_MESSAGE = "A valid password must be at least 8 characters long and contain" +
        " an uppercase letter, a lowercase letter and a digit";
    const PASSWORD_REGEX = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;
    function isValidPassword(password) {
        return PASSWORD_REGEX.test(password);
    }
    PasswordValidator.isValidPassword = isValidPassword;
})(PasswordValidator = exports.PasswordValidator || (exports.PasswordValidator = {}));
exports.default = PasswordValidator;
//# sourceMappingURL=password-validator.js.map